import { BaseAndCrudRoutes } from '@monorepo/tools/src/lib/routes/base.routes';

export class MyLinksRoutes extends BaseAndCrudRoutes {
	constructor() {
		super('my-links');
	}
}
